import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class ToastService {
	constructor(private toast: MessageService) {}

	public show(
		msj: string,
		detail?: any,
		severity: "success" | "info" | "warn" | "error" = "success"
	) {
		this.toast.add({
			key: "tst",
			severity: severity,
			summary: msj,
			detail: detail,
		});
	}
}
